import { reportError } from "../../utils/helpers";
import IProfilesRepository from "../IProfilesRepository";
import IDatabaseProvider from "../../providers/IDatabaseProvider";
import Profile from "../../entities/Profile";

class ProfilesRepository implements IProfilesRepository {
  constructor(private databaseProvider: IDatabaseProvider) {}

  public async getByUserId(userId: string): Promise<null | Profile> {
    try {
      const result = await this.databaseProvider.selectFirst("profiles", "*", "user_id", userId);
      return result ? Profile.fromJSON(result) : null;
    } catch (error: any) {
      reportError(error, { userId });
      return null;
    }
  }
}

export default ProfilesRepository;
